module.exports = __webpack_public_path__ + "img/1229505030.b4f48dc6.jpg";